import React from 'react';
import ReactDOM from 'react-dom';
import Tyres from "./Tyres";

const fields = document.getElementsByTagName('input');
const checklistRegex = new RegExp(/\[tyres\]/);
let tyresValue;
let fieldName;

for (let i in fields) {
  if (checklistRegex.test(fields[i].name)) {
    tyresValue = fields[i].value;
    fieldName = fields[i].name;
  }
}

if (tyresValue !== '') {
  tyresValue = JSON.parse(tyresValue);
} else {
  tyresValue = [];
}
ReactDOM.render(
  <Tyres tyres={tyresValue} config={window.TYRES_APP_CONFIG} fieldName={fieldName} />,
  document.getElementById('tyres-app')
);
